import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdateRoleForm from "../../forms/CreateOrUpdateRoleForm";

const CreateRoleModal = ({ open, onClose, loading, error }) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Create New Role"
      width="sm"
      loading={loading}
    >
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <CreateOrUpdateRoleForm loading={loading} />
    </AppModal>
  );
};

export default CreateRoleModal;
